import {WizardComponentController} from "../WizardComponent";

export const WizardCancel = "wizardCancel";

export function wizardCancel() {
  return {
    restrict: "A",
    require: "^^tfWizard",
    link: ($scope: ng.IScope, $elem: ng.IRootElementService, $attr: ng.IAttributes, wizard: WizardComponentController) => {
      $elem.on("click", () => {
        wizard.cancel();
      });
    }
  };
}
